import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IPaymentWalletTypeData, IPaymentWalletTypeResponse } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentWalletListAPI = () => {
  const configuration = useConfiguration();
  const [walletType, setWalletType] = useState<IPaymentWalletTypeData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: ICartAPIResponse = await axios
        .get(`${PAYMENT_MODULE?.USER_WALLET_TYPE?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IPaymentWalletTypeResponse>) => {
          if (res.data.status === true) {
            setWalletType(res.data.data);

            return { status: true, message: "Cart Level Coupons Fetched" };
          } else {
            setWalletType([]);

            return { status: false, message: "No Cart Level Coupons" };
          }
        })
        .catch((e: AxiosError) => {
          setWalletType([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e);

          return { status: false, message: "cart_not_filtered" };
        });
      return response;
    } catch (e: any) {
      setWalletType([]);
      captureError(e);
    }
  }, [dispatch]);
  return { walletType, execute };
};
